import { Component, OnInit, ViewChild } from '@angular/core';
import { ShipService } from '../../services/ship.service';
import { ShipRosterIdentity } from '../../data/ShipRosterIdentity';
import { Ship } from '../../Ship';
import { EntitlementService } from '../../services/entitlement.service';
import { ShipRoundTripHistory } from '../../data/ShipRoundTripHistory';
import { RoundTripHistoryComponent } from '../round-trips/round-trip-history/round-trip-history.component';
import { FleetInformationComponent } from '../round-trips/fleet-information/fleet-information.component';
import { RoundTripOverviewComponent } from '../round-trips/round-trip-overview/round-trip-overview.component';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { SearchService } from '../../services/search.service';
import { FormUtils } from '../../FormUtils';
import { CardholderService } from '../../services/cardholder.service';
import { MessageService } from '../../services/message.service';
import { ProfileSearchResult } from '../../data/ProfileSearchResult';
import { Subscription } from 'rxjs';
import { Identity } from '../../Identity';
import { Merchant } from '../../Merchant';
import { MerchantService } from '../../services/merchant.service';
import {ShipInstallation} from "../../data/ShipInstallation";

@Component({
  selector: 'app-ship-roster',
  templateUrl: './ship-roster.component.html',
  styleUrls: ['./ship-roster.component.css']
})
export class ShipRosterComponent implements OnInit {
  public identities: ShipRosterIdentity[];
  public transferIds: number[] = [];
  public profileSearchResults: ProfileSearchResult[];
  public ship: Ship;
  public processing = false;
  public page = 1;
  public pageSize = 25;
  @ViewChild('roundTripHistory', { static: false })
  roundTripHistory: RoundTripHistoryComponent;
  @ViewChild('fleetInformation', { static: false })
  fleetInformation: FleetInformationComponent;
  @ViewChild('roundTripOverview', { static: false })
  roundTripOverview: RoundTripOverviewComponent;
  shipResultArray: Ship[];
  shipRoundTripHistory: ShipRoundTripHistory;
  rosterSearchForm: UntypedFormGroup;
  firstParameter: string;
  firstType: string;
  methods = [];
  searchResults = [];
  subview: string;
  tempIdentities: ShipRosterIdentity[];
  isBranch: boolean = false;
  filters: boolean = false;
  branches = [];
  isMarines = false;
  spinnerFlag: boolean = false;
  @ViewChild('val1', { static: false }) inputName1;
  @ViewChild('val2', { static: false }) inputName2;
  @ViewChild('opt', { static: false }) typeName;
  subscriptions: Subscription[] = [];
  aoMerchants: Merchant[] = [];
  identityAO: Identity;
  transferIdsCheckAO: number[] = [];
  shipInstallations: ShipInstallation[];

  constructor(
    private entitlementService: EntitlementService,
    private shipService: ShipService,
    private router: Router,
    private searchService: SearchService,
    private formUtils: FormUtils,
    private cardholderService: CardholderService,
    private merchantService: MerchantService,
    private messageService: MessageService,
    private toastrService: ToastrService
  ) {}

  ngOnInit() {
    this.ship = this.shipService.retrieveShipProfile();
    this.shipService.getShipRoster(this.ship.shipLocation).subscribe(
      (response) => {
        this.identities = response;
      },
      (error) => {
        console.log('Error retrieving ship roster: ' + error);
        this.toastrService.error(
          'There was a problem fetching the ship roster '
        );
      }
    );
    this.shipResultArray = this.shipService.retieveAllShipProfileResults();
    if (this.ship == null) {
      this.router.navigate(['/shipProfiles']);
    }
    this.shipService.getLastSeen(this.ship.shipLocation).subscribe(
      (data: ShipInstallation[]) => {
        this.shipInstallations = data;

      },
      (error) => { console.log('There was a problem getting Ship Round Trip History: ' + error); },
      () => {}
    );
    this.shipService.getShipRoundTripHistory(this.ship.shipLocation).subscribe(
      (data: ShipRoundTripHistory) => {
        this.shipRoundTripHistory = data;
      },
      (error) => {
        console.log(
          'There was a problem getting Ship Round Trip History: ' + error
        );
      },
      () => {}
    );
    this.shipService
      .getShipBranches(this.ship.shipLocation)
      .subscribe((response) => {
        this.branches = response;        
      });
    this.methods = this.searchService.searchRosterMethod();
    this.firstType = this.methods[0];
    this.isMarines = ['MLG001', 'MLG002', 'MLG003'].includes(this.ship.shipLocation);
    this.initForm();
  }

  initForm() {
    this.rosterSearchForm = new UntypedFormGroup({
      firstParameter: new UntypedFormControl('', [Validators.required]),
      firstType: new UntypedFormControl(this.firstType)
    });

    this.rosterSearchForm
      .get('firstParameter')
      .valueChanges.subscribe((data) => {
        this.firstParameter = data;
        this.validate();
      });
  }

  getUserProfile(acct_num) {
    this.cardholderService.getCardholdersByPayrollAccount(acct_num).subscribe(
      (data: ProfileSearchResult[]) => {
        this.profileSearchResults = data;
      },
      () => {},
      () => {
        CardholderService.storeCardHolder(this.profileSearchResults[0]);
        this.cardholderService.storeCardholderResult(
          this.profileSearchResults[0]
        );
        this.router.navigate(['/cardholderProfiles/personal']);
      }
    );
  }

  validate() {
    this.rosterSearchForm.controls['firstParameter'].setErrors(null);
    if (this.firstParameter.length < 1) {
      this.rosterSearchForm.controls['firstParameter'].setErrors({
        required: true
      });
      return;
    }
    if (this.firstType === 'First and Last Name') {
      if (this.firstParameter.length < 2) {
        this.rosterSearchForm.controls['firstParameter'].markAsTouched();
        this.rosterSearchForm.controls['firstParameter'].setErrors({
          nameError: true
        });
        return;
      }
    }

    if (this.firstType === 'Last 4-digits of SSN') {
      if (this.firstParameter.length < 4) {
        this.rosterSearchForm.controls['firstParameter'].markAsTouched();
        if (!this.firstParameter.match(/^\d{0,3}$/)) {
          this.rosterSearchForm.controls['firstParameter'].setErrors({
            ssnError: true
          });
          return;
        }
        this.rosterSearchForm.controls['firstParameter'].setErrors({
          ssnLenError: true
        });
        return;
      }
      if (!this.firstParameter.match(/^\d{4}$/)) {
        this.rosterSearchForm.controls['firstParameter'].markAsTouched();
        if (this.firstParameter.length > 4) {
          this.rosterSearchForm.controls['firstParameter'].setErrors({
            ssnLenError: true
          });
          return;
        }
        this.rosterSearchForm.controls['firstParameter'].setErrors({
          ssnError: true
        });
        return;
      }
    } else {
      this.rosterSearchForm.controls['firstParameter'].setErrors(null);
    }
  }

  searchRosterCardholders() {
    this.formUtils.markFormFieldsAsTouched(this.rosterSearchForm);
    if (!this.rosterSearchForm.valid) {
      return false;
    }
    this.subview = 'spinner';
    this.spinnerFlag = true;
    this.firstParameter.replace(' ', '_');
    this.firstType.replace(' ', '_');
    this.shipService
      .getShipRoster(
        this.ship.shipLocation,
        this.firstParameter,
        this.firstType
      )
      .subscribe(
        (data) => {
          this.tempIdentities = this.identities;
          if (data.length === 0) {
            this.spinnerFlag = false;
            this.filters = true;
            this.subview = 'noResults';
          } else {
            this.searchResults = data;
            this.identities = this.searchResults;
            this.filters = true;
            this.spinnerFlag = false;
            this.subview = 'results';
          }
        },
        (error) => {
          console.log(error);
          this.messageService.error('Error in search');
        }
      );
  }

  clearFilters() {
    this.rosterSearchForm.markAsUntouched();
    this.identities = this.tempIdentities;
    this.clear();
    this.subview = '';
    this.filters = false;
  }

  clear() {
    this.rosterSearchForm.controls.firstParameter.setValue('');
    if (this.isBranch) {
      this.inputName2.nativeElement.value = '';
    } else {
      this.inputName1.nativeElement.value = null;
    }
  }

  changeMethod(event) {
    const type = event.target.value;
    this.firstType = type;
    this.isBranch = this.firstType === 'Branch';
    this.validate();
    this.clear();
  }

  hasNoMEU(identity: string) {
    return identity == null;
  }

  addTransfer(id: number) {
    this.transferIds.push(id);
  }

  removeTransfer(id: number): void {
    this.transferIds.splice(this.transferIds.indexOf(id), 1);
  }

  transfer(): void {
    this.processing = true;
    this.shipService
      .transfer(this.ship.shipLocation, this.transferIds)
      .subscribe(
        (transferResponse) => {
          this.transferIdsCheckAO = this.transferIds;
          this.transferIds = transferResponse;
          if (this.transferIds.length !== 0) {
            this.toastrService.error(
              'There was an error processing some of your requests.'
            );
          } else {
            this.shipService.getShipRoster(this.ship.shipLocation).subscribe(
              (rosterResponse) => {
                this.identities = rosterResponse;
                this.processing = false;
                this.toastrService.success('Updated Ship Roster Successfully');
              },
              (error) => {
                console.log('Error retrieving ship roster: ' + error);
                this.toastrService.error(
                  'There was a problem fetching the ship roster '
                );
                this.identities = null;
              }
            );

            this.shipService
              .checkTransferForAO(this.transferIdsCheckAO)
              .subscribe((data) => {
                this.aoMerchants = data;
                if (this.aoMerchants != null) {
                  for (let merchant of this.aoMerchants) {
                    this.merchantService
                      .saveAccountableOfficial(
                        0,
                        merchant.ncMerchantNum,
                        merchant.location
                      )
                      .subscribe(
                        () => {},
                        (error) => {
                          if (error.error) {
                            this.messageService.error(error.error);
                          }
                        }
                      );
                  }
                }
              });
          }
        },
        (error) => {
          this.processing = false;
          console.log('There was an error updating the ship roster: ' + error);
          this.toastrService.error(
            'There was an error updating the ship roster'
          );
        },
        () => {}
      );
  }

  hasEntitlement(entitlement: string) {
    return this.entitlementService.hasEntitlement(entitlement);
  }

  isSaveDisabled(): boolean {
    return this.processing || this.transferIds.length === 0;
  }

  onShipChange(newShip: Ship) {
    this.ship = newShip;
    this.shipService.storeShipProfile(this.ship);
    this.shipService.getShipRoundTripHistory(this.ship.shipLocation).subscribe(
      (data: ShipRoundTripHistory) => {
        this.shipRoundTripHistory = data;
      },
      (error) => {
        console.log(
          'There was a problem getting Ship Round Trip History: ' + error
        );
      },
      () => {
        this.fleetInformation.updateShipData(this.ship);
        this.roundTripHistory.updateShipData(this.ship, this.shipRoundTripHistory, this.shipInstallations);
        this.roundTripOverview.updateShipData(this.ship, this.shipRoundTripHistory, this.shipInstallations);
      }
    );
  }
  isShipNotShore(currentShip: Ship) {
    return !(
      currentShip.shipLocation.includes('MLG') ||
      currentShip.shipName === 'SHORE COMMAND'
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }
}
